var _ScopedLogger_instances, _ScopedLogger_name, _ScopedLogger_logger, _ScopedLogger_disposed, _ScopedLogger_prepareMessage, _ScopedLogger_ensureNotDisposed;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import SR from '../i18n/en/generic.strings.json';
export default class ScopedLogger {
    constructor(logger, name) {
        _ScopedLogger_instances.add(this);
        _ScopedLogger_name.set(this, void 0);
        _ScopedLogger_logger.set(this, void 0);
        _ScopedLogger_disposed.set(this, false);
        __classPrivateFieldSet(this, _ScopedLogger_logger, logger, "f");
        __classPrivateFieldSet(this, _ScopedLogger_name, name, "f");
        if (ScopedLogger.isScopedLogger(logger)) {
            this._scope = [...logger._scope, name];
        }
        else {
            this._scope = [name];
        }
    }
    static isScopedLogger(subject) {
        return subject["_scope"] !== undefined;
    }
    debug(msg, ...args) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldGet(this, _ScopedLogger_logger, "f").debug(__classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_prepareMessage).call(this, msg), ...args);
    }
    debugError(err, msg, ...args) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldGet(this, _ScopedLogger_logger, "f").debugError(err, __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_prepareMessage).call(this, msg), ...args);
    }
    error(msg, ...args) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldGet(this, _ScopedLogger_logger, "f").error(__classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_prepareMessage).call(this, msg), ...args);
    }
    errorError(err, msg, ...args) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldGet(this, _ScopedLogger_logger, "f").errorError(err, __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_prepareMessage).call(this, msg), ...args);
    }
    info(msg, ...args) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldGet(this, _ScopedLogger_logger, "f").info(__classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_prepareMessage).call(this, msg), ...args);
    }
    infoError(err, msg, ...args) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldGet(this, _ScopedLogger_logger, "f").infoError(err, __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_prepareMessage).call(this, msg), ...args);
    }
    trace(msg, ...args) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldGet(this, _ScopedLogger_logger, "f").trace(__classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_prepareMessage).call(this, msg), ...args);
    }
    traceError(err, msg, ...args) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldGet(this, _ScopedLogger_logger, "f").traceError(err, __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_prepareMessage).call(this, msg), ...args);
    }
    warn(msg, ...args) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldGet(this, _ScopedLogger_logger, "f").warn(__classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_prepareMessage).call(this, msg), ...args);
    }
    warnError(err, msg, ...args) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldGet(this, _ScopedLogger_logger, "f").warnError(err, __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_prepareMessage).call(this, msg), ...args);
    }
    scope(name) {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        return new ScopedLogger(this, name);
    }
    dispose() {
        __classPrivateFieldGet(this, _ScopedLogger_instances, "m", _ScopedLogger_ensureNotDisposed).call(this);
        __classPrivateFieldSet(this, _ScopedLogger_disposed, true, "f");
    }
}
_ScopedLogger_name = new WeakMap(), _ScopedLogger_logger = new WeakMap(), _ScopedLogger_disposed = new WeakMap(), _ScopedLogger_instances = new WeakSet(), _ScopedLogger_prepareMessage = function _ScopedLogger_prepareMessage(msg) {
    return `${ScopedLogger.openScope}${__classPrivateFieldGet(this, _ScopedLogger_name, "f")}${ScopedLogger.closeScope}${msg !== undefined ? ' ' : ''}${msg || null}`;
}, _ScopedLogger_ensureNotDisposed = function _ScopedLogger_ensureNotDisposed() {
    if (__classPrivateFieldGet(this, _ScopedLogger_disposed, "f")) {
        throw new Error(SR.objectIsDisposed);
    }
};
ScopedLogger.openScope = '[';
ScopedLogger.closeScope = ']';
